// extracted by mini-css-extract-plugin
module.exports = {"main":"not-found-module__G2V40q__main","text":"not-found-module__G2V40q__text","divider":"not-found-module__G2V40q__divider","redirection":"not-found-module__G2V40q__redirection"};